import { render, staticRenderFns } from "./kemudetail.vue?vue&type=template&id=ba09ced6&scoped=true&"
import script from "./kemudetail.vue?vue&type=script&lang=js&"
export * from "./kemudetail.vue?vue&type=script&lang=js&"
import style0 from "./kemudetail.vue?vue&type=style&index=0&id=ba09ced6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba09ced6",
  null
  
)

export default component.exports